export default __webpack_public_path__ + "media/nadEligibleHero.331e91e67734c6ea892ca8a9099dbad0.webp";